<template>
	<main class="wall" :class="{ bg }">
		<router-view v-if="campaignFirstLoad" :mouse="mouse" />
		<Loading v-else color="white" />
		<div class="debug" v-if="debug">
			<p>x: {{ pad(mouse.x) }}</p>
			<p>y: {{ pad(mouse.y) }}</p>
		</div>
	</main>
</template>

<script>
import campaign from '@/mixins/campaign'
import Loading from '@/components/shared/Loading'

export default {
	name: 'Wall',
	data() {
		return {
			mouse: { x: 0, y: 0 }
		}
	},
	computed: {
		debug() {
			return this.$route.query.hasOwnProperty('debug')
		},
		bg() {
			return this.$route.query.hasOwnProperty('bg') || this.debug
		}
	},
	methods: {
		onMousemove({ clientX: x, clientY: y }) {
			this.mouse = { x, y }
		},
		pad(n, s = 3) {
			return String(n).padStart(s, ' ')
		}
	},
	mounted() {
		window.addEventListener('mousemove', this.onMousemove)
	},
	beforeDestroy() {
		window.removeEventListener('mousemove', this.onMousemove)
	},
	mixins: [campaign],
	components: {
		Loading
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/components';

.wall {
	@extend %flex-col;
	width: 100%;
	height: 100vh;
	min-height: 736px;
	overflow: hidden;
	background: transparent;

	&.bg {
		background: $gradient-orange;
	}
}

.debug {
	position: absolute;
	top: 1rem;
	left: 1rem;
	font-family: 'Courier New', Courier, monospace;
	color: white;
	font-weight: bold;

	p {
		margin: 0;
		white-space: pre;
	}
}
</style>
